<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">


            <!--<div class="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <h4 class="fw-bold mb-0">Διαχείριση Αρχείων</h4>
            </div> -->

            <div class="row text-center g-3 mb-4">
                <div class="col-2 col">
                    <a href="#" class="menu-box d-block" :class="{ 'menu-box-active': activeSection === 'upload' }"
                        @click.prevent="activeSection = 'upload'">
                        <div class="menu-content">
                            <i class="icofont-upload-alt menu-img mb-2 mt-4 fs-2"></i>
                            <div class="fw-semibold mt-2" style="font-size: 16px;">Ανέβασμα</div>
                        </div>
                    </a>
                </div>

                <div class="col-2 col">
                    <a href="#" class="menu-box d-block" :class="{ 'menu-box-active': activeSection === 'categorize' }"
                        @click.prevent="activeSection = 'categorize'">
                        <div class="menu-content">
                            <i class="icofont-tags menu-img mb-2 mt-4 fs-2"></i>
                            <div class="fw-semibold mt-2" style="font-size: 16px;">Αρχεία</div>
                        </div>
                    </a>
                </div>

                
            </div>

            <div v-if="!activeSection" class="text-center text-secondary py-4">
                Επιλέξτε μία από τις παραπάνω λειτουργίες.
            </div>

            <!-- Upload -->
            <div class="card border-0 mb-4" v-if="activeSection === 'upload'">
                <div class="card-body">
                    <h6 class="fw-bold mb-3">Ανέβασμα εγγράφων</h6>

                    <!-- Πελάτης (CRM Clients) για τον οποίο ανεβαίνει το αρχείο -->
                    <div class="mb-3">
                        <label for="client">Πελάτης</label>
                        <Select2 id="client" :options="allClients" v-model="selectedClientId"
                            :settings="select2ClientSettings" @select="handleClientSelect" class="w-100" />
                    </div>
                    <div class="upload-dropzone" :class="{ 'is-dragover': isDragOver }"
                        @dragover.prevent="isDragOver = true" @dragleave.prevent="isDragOver = false"
                        @drop.prevent="handleDrop" @click="fileInput.click()">
                        <i class="icofont-upload-alt fs-2 mb-2"></i>
                        <p class="mb-0">Σύρετε αρχεία εδώ ή κάντε κλικ για επιλογή</p>
                        <input ref="fileInput" type="file" multiple class="d-none" @change="handleFileInputChange" />
                    </div>
                </div>
            </div>




            <!-- Αρχεία Πελατών: λίστα πελατών που έχουν διαθέσιμα αρχεία· δεύτερο κλικ σε πελάτη
                 ανοίγει dropdown με τα αρχεία του (ίδια αρχιτεκτονική με τη στήλη "Documents" στο Clients.vue) -->
            <div class="card border-0 mb-4" v-if="activeSection === 'categorize'">
                <div class="card-body">
                    <h6 class="fw-bold mb-3">Αρχεία Πελατών</h6>

                    <div class="list-group">
                        <div v-if="!clientsWithDocuments.length" class="text-center text-secondary py-3">
                            Δεν υπάρχουν πελάτες με διαθέσιμα αρχεία.
                        </div>
                        <div class="dropdown client-files-dropdown" v-for="client in clientsWithDocuments" :key="client.id"
                            @click="toggleClientDropdown(client.id)">
                            <a href="#" class="list-group-item list-group-item-action dropdown-toggle d-flex justify-content-between align-items-center"
                                :aria-expanded="openClientDropdownId === client.id" @click.prevent>
                                <span>{{ client.title }}</span>
                                <span class="badge bg-secondary rounded-pill">{{ documentCountForClient(client.id) }} έγγραφα</span>
                            </a>
                            <ul class="dropdown-menu files-dropdown  border-0 shadow p-2" :class="{ show: openClientDropdownId === client.id }"
                                style="min-width: 480px;">
                                <li>
                                    <div class="table-responsive">
                                        <table class="table table-sm table-hover align-middle mb-0 mis_table">
                                            <thead>
                                                <tr>
                                                    <th>Όνομα</th>
                                                    <th>Μέγεθος</th>
                                                    <th>Ανέβηκε από</th>
                                                    <th>Ημερομηνία</th>
                                                    <th class="text-center">Ενέργειες</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="doc in documentsForClient(client.id)" :key="doc.id">
                                                    <td>
                                                        <a :href="documentDownloadUrl(doc)" :download="doc.name">{{ doc.name }}</a>
                                                    </td>
                                                    <td>{{ formatSize(doc.sizeBytes) }}</td>
                                                    <td>{{ doc.uploadedByName || '-' }}</td>
                                                    <td>{{ formatDate(doc.uploadedAt) }}</td>
                                                    <td class="text-center">
                                                        <button type="button" class="btn btn-sm btn-outline-danger" title="Αρχειοθέτηση"
                                                            :disabled="!canArchiveDocument(doc)" @click="requestArchive(doc)">
                                                            <i class="icofont-archive"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Επιβεβαίωση αρχειοθέτησης — ελέγχεται χειροκίνητα με Vue state (όχι Bootstrap JS/data-bs-*),
                 ίδια λογική με το client-files dropdown παραπάνω, ώστε να λειτουργεί αξιόπιστα. -->
            <div v-if="pendingArchiveDoc" class="modal d-block archive-confirm-modal" tabindex="-1" style="background: rgba(0, 0, 0, 0.5);">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Επιβεβαίωση αρχειοθέτησης</h5>
                            <button type="button" class="btn-close" aria-label="Close" @click="cancelArchive"></button>
                        </div>
                        <div class="modal-body">
                            Είστε σίγουροι ότι θέλετε να αρχειοθετήσετε το αρχείο «{{ pendingArchiveDoc.name }}»;
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-secondary" @click="cancelArchive">Άκυρο</button>
                            <button type="button" class="btn btn-danger" @click="confirmArchive">Αρχειοθέτηση</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useToast } from 'vue-toastification';
import { getClientsServicesStatusesUsers } from '@/services/projects';
import { get as getClient } from '@/services/clients';
import { uploadToLocalDisk } from '@/services/documents';
import { useDocumentsStore } from '@/composables/useDocumentsStore';
import Select2 from 'vue3-select2-component';

export default {
    name: 'FileManagementMenu',
    components: {
        Select2
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const toast = useToast();

        // --- Ρόλοι / δικαιώματα ---
        // Πακέτο 'FILE MANAGEMENT' -> banner ενημέρωσης αν λείπει (η σελίδα είναι πάντα ορατή).
        const superUser = computed(() => store.getters.getSuperUserPermission === 1);
        const hasFileManagement = computed(() => store.getters.getUserPackets.includes('FILE MANAGEMENT'));
        const userPermissionsFiles = computed(() => store.getters.getUserPermission('Files'));
        const currentUserId = computed(() => store.getters.getUserId);
        const currentUsername = computed(() => store.state.userInfo?.username || 'Εγώ');

        const canUploadFile = computed(() => superUser.value || userPermissionsFiles.value?.create === 1);

        const isOwner = (doc) => String(currentUserId.value) === String(doc.uploadedBy);
        const canCategorizeDocument = (doc) =>
            superUser.value || userPermissionsFiles.value?.editAll === 1
            || (isOwner(doc) && userPermissionsFiles.value?.edit === 1);
        // Κατόπιν ρητού αιτήματος, η αρχειοθέτηση είναι διαθέσιμη σε κάθε χρήστη που βλέπει τη σελίδα,
        // χωρίς έλεγχο δικαιώματος 'archive' ή superUser (σε αντίθεση με τις υπόλοιπες ενέργειες).
        const canArchiveDocument = () => true;

        // Έλεγχος πρόσβασης πριν από κάθε ενέργεια (εκτός από το ανέβασμα, βλ. addFiles) — πρώτο βήμα σε κάθε handler.
        const requirePermission = (allowed, message) => {
            if (!allowed) {
                toast.error(message || 'Δεν έχετε δικαίωμα για αυτή την ενέργεια.');
                return false;
            }
            return true;
        };

        
        // Κοινόχρηστο state (useDocumentsStore — μόνιμη τοπική αποθήκευση σε IndexedDB) ώστε η στήλη
        // "Documents" στο Clients.vue να βλέπει τα ίδια δεδομένα.
        const { documents, addDocument, removeDocument, documentsForClient, documentDownloadUrl } = useDocumentsStore();
        const documentCountForClient = (clientId) => documentsForClient(clientId).length;
        const categories = ref(['']);
        const newCategoryName = ref('');
        const activeCategoryFilter = ref('all');
        const isDragOver = ref(false);
        const fileInput = ref(null);

        // Ποια από τις λειτουργίες (πλαίσια επιλογής) είναι ανοιχτή αυτή τη στιγμή
        const activeSection = ref(null); // null | 'upload' | 'categorize'

        // --- Πελάτης για τον οποίο ανεβαίνει το αρχείο (CRM Clients) ---
        // Το dropdown (Select2) φορτώνει όλους τους διαθέσιμους πελάτες και έχει ενσωματωμένο
        // πεδίο αναζήτησης ως πρώτο στοιχείο μόλις ανοίγει, για φιλτράρισμα της λίστας.
        const selectedClientId = ref(null);
        const selectedClientName = ref('');
        const allClients = ref([]);
        const select2ClientSettings = { placeholder: 'Επιλέξτε ή αναζητήστε πελάτη...', allowClear: true };

        const handleClientSelect = (data) => {
            selectedClientName.value = selectedClientId.value ? (data?.text || '') : '';
        };

        // Πελάτες που έχουν τουλάχιστον ένα διαθέσιμο αρχείο (για τη λίστα στο πεδίο "Αρχεία")
        const clientsWithDocuments = computed(() =>
            allClients.value
                .filter((c) => documentCountForClient(c.id) > 0)
                .map((c) => ({ id: c.id, title: c.text }))
        );

        // Dropdown με τα αρχεία ενός πελάτη: το data-bs-toggle="dropdown" της Bootstrap δεν ενεργοποιείται
        // εδώ (όπως στο Clients.vue), οπότε το άνοιγμα/κλείσιμο γίνεται χειροκίνητα με Vue state,
        // ίδια λογική με το άλλο dropdown του Clients.vue (isDropdownOpen/toggleDropdown).
        const openClientDropdownId = ref(null);
        const toggleClientDropdown = (clientId) => {
            openClientDropdownId.value = openClientDropdownId.value === clientId ? null : clientId;
        };
        const closeClientDropdownOnOutsideClick = (event) => {
            if (event.target.closest('.client-files-dropdown')) return;
            openClientDropdownId.value = null;
        };

        // Έρχεσαι εδώ από τη στήλη "Documents" του Clients.vue (?clientId=...) -> προεπιλογή του πελάτη
        onMounted(async () => {
            document.addEventListener('click', closeClientDropdownOnOutsideClick);

            const clientsResponse = await getClientsServicesStatusesUsers();
            const clients = clientsResponse?.data?.clients || [];
            allClients.value = clients.map((c) => ({ id: c.id, text: c.title }));

            const clientId = route.query.clientId;
            if (!clientId) return;

            // Έρχεσαι εδώ πατώντας ένα έγγραφο στη στήλη "Documents" του Clients.vue (?section=categorize)
            // -> άνοιγμα κατευθείαν στον πίνακα αρχείων του συγκεκριμένου πελάτη (τμήμα "Αρχεία"),
            // αντί για το τμήμα "Ανέβασμα".
            if (route.query.section === 'categorize') {
                activeSection.value = 'categorize';
                // client.id στη λίστα clientsWithDocuments είναι αριθμός (από το API), ενώ το
                // route.query.clientId είναι πάντα string -> μετατροπή, ώστε να ταιριάξει η αυστηρή
                // σύγκριση (openClientDropdownId === client.id) που ανοίγει το αντίστοιχο dropdown.
                openClientDropdownId.value = Number(clientId) || clientId;
                return;
            }

            selectedClientId.value = clientId;
            activeSection.value = 'upload';

            const existing = documents.value.find((d) => String(d.clientId) === String(clientId));
            if (existing?.clientTitle) {
                selectedClientName.value = existing.clientTitle;
                return;
            }

            const fromList = allClients.value.find((c) => String(c.id) === String(clientId));
            if (fromList?.text) {
                selectedClientName.value = fromList.text;
                return;
            }

            const response = await getClient({ id: clientId });
            selectedClientName.value = response?.data?.data?.title || response?.data?.title || `#${clientId}`;
        });

        onUnmounted(() => {
            document.removeEventListener('click', closeClientDropdownOnOutsideClick);
        });

        const formatSize = (bytes) => {
            if (!bytes) return '0 B';
            const units = ['B', 'KB', 'MB', 'GB'];
            const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
            return `${Math.round((bytes / Math.pow(1024, i)) * 10) / 10} ${units[i]}`;
        };

        const countByCategory = (cat) =>
            documents.value.filter((d) => (cat === null ? !d.category : d.category === cat)).length;

        const formatDate = (value) => {
            if (!value) return '-';
            const date = value instanceof Date ? value : new Date(value);
            if (isNaN(date)) return '-';
            return date.toLocaleDateString('el-GR');
        };

        const filteredDocuments = computed(() => {
            if (activeCategoryFilter.value === 'all') return documents.value;
            if (activeCategoryFilter.value === '__none__') return documents.value.filter((d) => !d.category);
            return documents.value.filter((d) => d.category === activeCategoryFilter.value);
        });

        // --- Ανέβασμα --- (χωρίς έλεγχο ρόλου σε αυτό το πεδίο, κατόπιν ρητού αιτήματος)
        // Το αρχείο γράφεται πραγματικά στο δίσκο (public/client-documents/<clientId>/..., μέσω
        // uploadToLocalDisk -> dev-server middleware, βλ. vue.config.js). Σε production build (όπου
        // δεν υπάρχει το endpoint) γίνεται fallback σε τοπική αποθήκευση του blob στο IndexedDB, όπως
        // πριν. Τα metadata (όνομα, κατηγορία, κοινή χρήση κ.λπ.) αποθηκεύονται πάντα στο IndexedDB
        // (βλ. useDocumentsStore) ώστε να επιβιώνουν σε refresh.
        const addFiles = async (fileList) => {
            if (!fileList?.length) return;

            const files = Array.from(fileList);
            for (const file of files) {
                const stored = await uploadToLocalDisk(file, selectedClientId.value);
                await addDocument({
                    name: file.name,
                    sizeBytes: file.size,
                    category: null,
                    uploadedBy: currentUserId.value,
                    uploadedByName: currentUsername.value,
                    uploadedAt: new Date(),
                    clientId: selectedClientId.value,
                    clientTitle: selectedClientName.value || null,
                    url: stored?.url || null,
                    blob: stored ? null : file
                });
            }
            const destination = selectedClientName.value ? ` για τον πελάτη ${selectedClientName.value}` : '';
            toast.success(`${files.length} αρχείο(α) αποθηκεύτηκαν${destination}.`);
        };

        const handleFileInputChange = (event) => {
            addFiles(event.target.files);
            event.target.value = '';
        };

        const handleDrop = (event) => {
            isDragOver.value = false;
            addFiles(event.dataTransfer.files);
        };

        // --- Κατηγορίες ---
        const addCategory = () => {
            if (!requirePermission(canUploadFile.value, 'Δεν έχετε δικαίωμα διαχείρισης κατηγοριών.')) return;
            const name = newCategoryName.value.trim();
            if (!name || categories.value.includes(name)) return;
            categories.value.push(name);
            newCategoryName.value = '';
        };

        const handleCategorize = (doc, category) => {
            if (!requirePermission(canCategorizeDocument(doc), 'Δεν έχετε δικαίωμα κατηγοριοποίησης αυτού του αρχείου.')) return;
            doc.category = category || null;
        };

        // --- Αρχειοθέτηση --- (με μήνυμα επιβεβαίωσης πριν την πραγματική ενέργεια)
        const pendingArchiveDoc = ref(null);

        const requestArchive = (doc) => {
            if (!requirePermission(canArchiveDocument(doc), 'Δεν έχετε δικαίωμα αρχειοθέτησης αυτού του αρχείου.')) return;
            pendingArchiveDoc.value = doc;
        };

        const cancelArchive = () => {
            pendingArchiveDoc.value = null;
        };

        const confirmArchive = async () => {
            const doc = pendingArchiveDoc.value;
            if (!doc) return;
            await removeDocument(doc.id);
            toast.success('Το αρχείο αρχειοθετήθηκε.');
            pendingArchiveDoc.value = null;
        };

        return {
            hasFileManagement,
            activeSection,
            canUploadFile,
            canCategorizeDocument,
            canArchiveDocument,
            documents,
            categories,
            newCategoryName,
            activeCategoryFilter,
            isDragOver,
            fileInput,
            selectedClientId,
            selectedClientName,
            allClients,
            select2ClientSettings,
            handleClientSelect,
            filteredDocuments,
            countByCategory,
            formatSize,
            formatDate,
            documentsForClient,
            documentCountForClient,
            clientsWithDocuments,
            openClientDropdownId,
            toggleClientDropdown,
            documentDownloadUrl,
            handleFileInputChange,
            handleDrop,
            addCategory,
            handleCategorize,
            pendingArchiveDoc,
            requestArchive,
            cancelArchive,
            confirmArchive
        };
    },
    metaInfo: {
        title: 'File Management Menu',
        meta: [
            { name: 'description', content: 'File Management Menu' },
            { property: 'og:title', content: 'File Management Menu' },
            { property: 'og:description', content: 'Διαχείριση Αρχείων' }
        ]
    }
};
</script>

<style scoped>
.upload-dropzone {
    max-width: 60%;
    border: 2px dashed #c3c2b7;
    border-radius: 12px;
    padding: 2.5rem 1rem;
    text-align: center;
    color: #52514e;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.upload-dropzone:hover,
.upload-dropzone.is-dragover {
    border-color: #0b0b0ba6;
    background: #f9fafb;
}

.menu-box-active {
    border-color: #0b0b0b52;
    background-color: #e9ecef;
    box-shadow: #0b0b0b52;
}

.dropdown-menu.show {
    display: block;
}

/* Επιβεβαίωση αρχειοθέτησης — προσάρμοσε ελεύθερα τα παρακάτω */
.archive-confirm-modal .modal-dialog {
    display: flex;
    width: 100%;
    max-width: 550px;
}

.archive-confirm-modal .modal-content {
    display: flex;
    justify-content: center;
    border: 0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.archive-confirm-modal .modal-header {
    border-bottom: 1px solid #f1f1f1;
    padding-left: 26%;
}

.archive-confirm-modal .modal-title {
    font-weight: 600;
    font-size: 1.05rem;
}

.archive-confirm-modal .modal-body {
    padding: 1.25rem;
    color: #52514e;
}

.archive-confirm-modal .modal-footer {
    border-top: 0;
    padding-top: 0;
}
</style>
